var render, staticRenderFns
import script from "./Automn.vue?vue&type=script&lang=js&"
export * from "./Automn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Automn.vue"
export default component.exports